// src/components/StructuredData.jsx
import { Helmet } from 'react-helmet-async';

/**
 * StructuredData component injects JSON-LD structured data for SEO
 * This helps Google understand your business and show rich results
 */
function StructuredData() {
    const organizationSchema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Torque Energy",
        "url": "https://torqueenergy.shop",
        "logo": "https://torqueenergy.shop/logo512.png",
        "description": "Premium energy drinks crafted with natural ingredients for clean, sustained energy without the crash.",
        "sameAs": [
            // Add your social media profiles here when available
            // "https://www.facebook.com/torqueenergy",
            // "https://twitter.com/torqueenergy",
            // "https://www.instagram.com/torqueenergy"
        ],
        "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "Customer Service",
            "url": "https://torqueenergy.shop/contact"
        }
    };

    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Torque Energy Drinks",
        "description": "Clean, sustained energy without the crash. Premium energy drinks with natural ingredients.",
        "brand": {
            "@type": "Brand",
            "name": "Torque Energy"
        },
        "offers": {
            "@type": "AggregateOffer",
            "availability": "https://schema.org/InStock",
            "priceCurrency": "USD",
            "url": "https://torqueenergy.shop/products"
        }
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(organizationSchema)}
            </script>
            <script type="application/ld+json">
                {JSON.stringify(productSchema)}
            </script>
        </Helmet>
    );
}

export default StructuredData;
